// In the long run it may be best to define pure functions outside of Angular

import { ApplicationPermissionsResult } from '../../../types/types';

// and expose them as pipes when necessary;
export function hasPermissionWithAccess(
  permission: ApplicationPermissionsResult | undefined,
): boolean {
  return (permission || {}).hasAccess || false;
}
